/* Draft homepage: full product photos and precisely aligned desktop/mobile rails. */
(() => {
  if (!document.body.classList.contains('index-template')) return;
  if (window.__amcHomeRails20261028) return;
  window.__amcHomeRails20261028 = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const imageSelector = [
    '.amc-trending-card__image > img',
    '.amc-market-card__media-link > img',
    '.amc-cslider__media-link > img'
  ].join(',');
  const imageRules = {
    position: 'absolute', inset: '10px', left: '10px', top: '10px',
    right: '10px', bottom: '10px',
    width: 'calc(100% - 20px)', height: 'calc(100% - 20px)',
    'min-width': '0', 'min-height': '0', 'max-width': 'none',
    'max-height': 'none', margin: '0', padding: '0',
    'object-fit': 'contain', 'object-position': 'center',
    'aspect-ratio': 'auto', transform: 'none', translate: 'none',
    scale: 'none', rotate: 'none', 'clip-path': 'none',
    filter: 'none', 'mix-blend-mode': 'normal', background: '#fff'
  };
  function fitPhotos(scope) {
    scope.querySelectorAll(imageSelector).forEach(img => {
      img.classList.add('amc-home-full-image');
      const frame = img.parentElement;
      frame.classList.add('amc-home-image-frame');
      for (const [key, value] of Object.entries({
        position: 'relative', transform: 'none', background: '#fff',
        overflow: 'hidden', 'box-sizing': 'border-box'
      })) frame.style.setProperty(key, value, 'important');
      for (const [key, value] of Object.entries(imageRules)) {
        img.style.setProperty(key, value, 'important');
      }
    });
  }
  function init(scope) {
    fitPhotos(scope);
    scope.querySelectorAll('.amc-quickrow[data-qr]').forEach(root => {
      if (root.dataset.qrReady) return;
      const rail = root.querySelector('.amc-trending__rail');
      if (!rail || !rail.children.length) return;
      root.dataset.qrReady = 'true';
      // The selector controller owns autoplay for every homepage row.
      // Keep this controller's existing manual arrows, without a competing timer.
      const automatic = false;
      const lifetime = new AbortController();
      const on = (el, name, fn, opts = {}) => el?.addEventListener(
        name, fn, { ...opts, signal: lifetime.signal }
      );
      let visible = false, hovered = false, touching = false, paused = false;
      let resumeAfter = 0, timer = null;
      let play;
      const positions = () => {
        const first = rail.firstElementChild.getBoundingClientRect().left;
        const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        return [...new Set([...rail.children].map(card => Math.min(max,
          Math.max(0, Math.round(card.getBoundingClientRect().left - first))
        )))];
      };
      function go(direction) {
        const stops = positions();
        const here = rail.scrollLeft;
        const next = direction > 0
          ? (stops.find(x => x > here + 3) ?? 0)
          : ([...stops].reverse().find(x => x < here - 3) ?? stops.at(-1));
        rail.scrollTo({ left: next, behavior: motion.matches ? 'auto' : 'smooth' });
      }
      function updatePlay() {
        if (!play) return;
        const stopped = paused || motion.matches;
        play.textContent = stopped ? '▶' : 'Ⅱ';
        play.setAttribute('aria-label',
          `${stopped ? 'Play' : 'Pause'} automatic ${rail.getAttribute('aria-label')}`);
        play.setAttribute('aria-pressed', String(!stopped));
        root.dataset.qrAutoplay = stopped ? 'paused' : 'enabled';
      }
      const manual = direction => {
        resumeAfter = Date.now() + 8000;
        go(direction);
      };
      on(root.querySelector('[data-qr-prev]'), 'click', () => manual(-1));
      on(root.querySelector('[data-qr-next]'), 'click', () => manual(1));
      if (!automatic) return;
      // Preserve compact two-card mobile presentation, but as a real swipe rail.
      const mobile = matchMedia('(max-width: 749px)');
      const mobileRules = {
        display: 'grid', 'grid-template-columns': 'none',
        'grid-template-rows': '1fr', 'grid-auto-flow': 'column',
        'grid-auto-columns': 'calc((100% - 12px) / 2)',
        gap: '12px', 'overflow-x': 'auto', 'overflow-y': 'hidden',
        'scroll-snap-type': 'x mandatory'
      };
      function responsiveRail() {
        const columns = mobile.matches ? 2 : innerWidth < 1200 ? 3 : 4;
        mobileRules['grid-auto-columns'] = `calc((100% - ${(columns - 1) * 12}px) / ${columns})`;
        for (const [key, value] of Object.entries(mobileRules)) {
          rail.style.setProperty(key, value, 'important');
        }
        [...rail.children].forEach(card => {
          card.style.setProperty('grid-column', 'auto', 'important');
          card.style.setProperty('scroll-snap-align', 'start', 'important');
        });
      }
      responsiveRail();
      on(mobile, 'change', responsiveRail);
      on(window, 'resize', responsiveRail);
      rail.setAttribute('aria-live', 'off');
      play = document.createElement('button');
      play.type = 'button';
      play.className = 'amc-rail-play';
      // Older mobile rules hide every nav button; retain the accessible pause.
      for (const [key, value] of Object.entries({
        display: 'inline-flex', 'align-items': 'center', 'justify-content': 'center',
        width: '30px', height: '30px', 'min-width': '30px', 'min-height': '30px',
        flex: '0 0 30px', margin: '0 6px', 'font-size': '12px'
      })) play.style.setProperty(key, value, 'important');
      root.querySelector('.amc-trending__nav')?.append(play);
      updatePlay();
      on(play, 'click', () => {
        paused = !paused;
        resumeAfter = Date.now() + 4500;
        updatePlay();
      });
      on(root, 'pointerenter', e => { if (e.pointerType === 'mouse') hovered = true; });
      on(root, 'pointerleave', () => { hovered = false; });
      on(root, 'pointerdown', () => { touching = true; resumeAfter = Date.now() + 8000; });
      on(window, 'pointerup', () => { touching = false; });
      on(window, 'pointercancel', () => { touching = false; });
      on(rail, 'wheel', () => { resumeAfter = Date.now() + 8000; }, { passive: true });
      on(motion, 'change', updatePlay);
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting;
      }, { threshold: 0.25 });
      observer.observe(rail);
      timer = setInterval(() => {
        if (!root.isConnected) return cleanup();
        if (!visible || paused || hovered || touching || motion.matches ||
            document.hidden || Date.now() < resumeAfter ||
            root.contains(document.activeElement) ||
            document.querySelector('.amc-card-option-modal:not([hidden]),.amc-bf:not([hidden])')) return;
        if (rail.scrollWidth > rail.clientWidth + 3) go(1);
      }, 4500);
      function cleanup() {
        clearInterval(timer);
        observer.disconnect();
        lifetime.abort();
      }
      on(document, 'shopify:section:unload', e => {
        if (e.target.contains(root)) cleanup();
      });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
